<template>
	<div
		class="d-flex flex-column justify-center align-center"
		style="background-color:#d2d6de;background-size:cover;background-attachment:fixed;min-height:100vh;display:flex;flex-direction:column;"
	>
		<v-form ref="form" v-model="valid" @submit.prevent="submit()">
			<v-card width="360">
				<v-card-title
					class="title d-flex justify-center align-center mb-4"
					style="background-color:#003366;color:white;"
				>
					<v-img max-width="150" :src="baseLocation + '/resource/image/v-unite-logo.png'"></v-img>
				</v-card-title>
				<v-card-text  v-if="!isSuccess">
					<v-text-field v-model="user.email" label="E-mail" :rules="[(v) =>!!v ||'E-mail is required',]" v-show="false"  required></v-text-field>
					<v-text-field
						v-model="password"
						:rules="passwordRule"
						:type="passwordFieldType"
						:append-icon="passwordFieldType === 'password' ? 'mdi-eye' : 'mdi-eye-off'"
						@click:append="switchVisibility1"
						label="Password"
						required
					></v-text-field>

					<v-text-field
						v-model="confirmPassword"
						:rules="confirmPasswordRule"
						:type="confirmPasswordFieldType"
						:append-icon="confirmPasswordFieldType === 'password' ? 'mdi-eye' : 'mdi-eye-off'"
						@click:append="switchVisibility2"
						label="Confirm Password"
						required
					></v-text-field>
					<v-row class="text-right" style="margin: 0" justify="end">
						<v-col cols="12" sm="8">
							<v-btn  :disabled="!valid" type="submit" color="primary darken-1" depressed tile>Submit Password</v-btn>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-text v-else class="text-center">
					<h2 class="display-1">Thank you</h2>
					<br />
					<p>Password was set successfully.</p>
					<v-btn
						color="primary darken-1"
						:to="'/tenant'"						
					>Back to login</v-btn>
				</v-card-text>
			</v-card>
		</v-form>
	</div>
</template>


<script>
import axios from "axios";

export default {
	props: ["tenantSlug", "experienceSlug", "token"],
	data() {
		return {
			valid: true,
			password: null,
			passwordRule: [(v) =>!!v ||'Please specify password'],
			confirmPassword: null,
			confirmPasswordRule:[
				v => !!v || 'Please confirm your password',
				v => (v && v === this.password) || 'The password does not match'
			],
			user: {},
			isSuccess: false,
			isCreatePassword: false,
			passwordFieldType: "password",
			confirmPasswordFieldType: "password",
			baseLocation: axios.defaults.baseURL
		};
	},
	mounted: function() {
		this.validate();
	},
	methods: {
		validate() {
			this.isCreatePassword = this.$route.path.includes("/createpassword/");			
			axios
				.get("/system/authentication/tenant/resetpassword/isvalid?token=" + this.token)
				.then(response => {
					this.user = response.data;
				})
				.catch(() => {});
		},
		submit(){
			if(this.isCreatePassword){
				this.createPassword();
			} else {
				this.resetPassword();
			}
		},
		createPassword() {
			axios
				.post("/system/authentication/tenant/createpassword/validate", {
					token: this.token,
					password: this.password
				})
				.then(response => {
					this.isSuccess = response.data;
					this.$refs.form.reset();
				})
				.catch(() => {});
		},
		resetPassword: function() {
			axios
				.post("/system/authentication/tenant/resetpassword/validate", {
					token: this.token,
					password: this.password
				})
				.then(response => {
					this.isSuccess = response.data;
					this.$refs.form.reset();
				})
				.catch(() => {});
		},
		switchVisibility1() {
			this.passwordFieldType = this.passwordFieldType === "password" ? "text" : "password";
		},
		switchVisibility2() {
			this.confirmPasswordFieldType = this.confirmPasswordFieldType === "password" ? "text" : "password";
		},
	}
};
</script>